import React, { Component, PropTypes } from 'react';
import { AutoComplete, Divider, TextField, Toggle, Table, TableBody, TableFooter, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, IconButton, FlatButton, RaisedButton, Dialog, Paper } from 'material-ui';
import { Link } from 'react-router-dom';
import EditorModeEdit from 'material-ui/svg-icons/editor/mode-edit';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import { styleUser } from './style';
import { Row, Col } from 'react-flexbox-grid';
import AddUser from './add';
import EditUser from './edit';
import autoBind from 'react-autobind';
import * as actions from '../../actions';
import DataTables from 'material-ui-datatables';
import {List} from 'immutable';
import {SortListOrder} from '../../actions/datatable';
import NavigationMoreVert from 'material-ui/svg-icons/navigation/more-vert';

class TableUser extends Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        
      </div>
    );
  }

}

class TableUsers extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fixedHeader: true,
            fixedFooter: true,
            stripedRows: false,
            showRowHover: true,
            selectable: false,
            multiSelectable: false,
            enableSelectAll: false,
            deselectOnClickaway: true,
            showCheckboxes: false,
            height: 'auto',
            openEdit:false,
            openDelete:false,
            password:'',
            user:{},
            userId:0,
            loginName:''
        };
        autoBind(this);
    }

    handleOpenDelete = (userId,loginName) => {
        this.setState({
            openDelete: true,
            userId:userId,
            loginName:loginName
        });
    };

    handleCloseDelete = () => {
        this.setState({openDelete: false});
    };

    handleOpenEdit = (user,loginName) => {
        this.setState({
            openEdit: true,
            user:user,
            loginName:loginName
        });
    };

    handleCloseEdit = () => {
        this.setState({openEdit: false});
    };

    handleDeleteUser(id){
        if (id > -1 ) {
            this.props.dispatch(actions.getUserId(id));
            this.props.dispatch(actions.deleteUser(id,false));
            this.handleCloseDelete();
        }
    }

    render() {
        return (
            <div>
                <Dialog 
                        title={"Sửa người dùng: " + this.state.loginName } 
                        modal={ false } 
                        open={ this.state.openEdit } 
                        onRequestClose={ this.handleCloseEdit } 
                        autoScrollBodyContent={ true }>
                        <EditUser 
                            user={this.state.user}
                            dispatch={this.props.dispatch} 
                            handleClose={this.handleCloseEdit}
                            initialValues={this.state.user}
                        />
                </Dialog>

                <Dialog
                    actions={
                        <div>
                            <FlatButton
                                label="Hủy"
                                primary={false}
                                onTouchTap={this.handleCloseDelete}
                            />
                            <RaisedButton
                                label="Xóa"
                                secondary ={true}
                                onTouchTap={() => this.handleDeleteUser(this.state.userId)}
                            />
                        </div>
                    }
                    modal={false}
                    open={this.state.openDelete}
                    onRequestClose={this.handleCloseDelete}
                >
                    {'Bạn có muốn xóa người dùng '+ this.state.loginName + '?'}
                </Dialog>

                <Table 
                    height={ this.state.height } 
                    fixedHeader={ this.state.fixedHeader } 
                    fixedFooter={ this.state.fixedFooter } 
                    selectable={ this.state.selectable } 
                    multiSelectable={ this.state.multiSelectable }>
                    <TableHeader 
                        displaySelectAll={ this.state.showCheckboxes } 
                        adjustForCheckbox={ this.state.showCheckboxes } 
                        enableSelectAll={ this.state.enableSelectAll }>
                        <TableRow>
                            <TableHeaderColumn tooltip="Tên người dùng">Tên người dùng</TableHeaderColumn>
                            <TableHeaderColumn tooltip="Họ tên">Họ và tên</TableHeaderColumn>
                            <TableHeaderColumn tooltip="Email">Email</TableHeaderColumn>
                            <TableHeaderColumn></TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody 
                        displayRowCheckbox={ this.state.showCheckboxes } 
                        deselectOnClickaway={ this.state.deselectOnClickaway } 
                        showRowHover={ this.state.showRowHover } 
                        stripedRows={ this.state.stripedRows }>

                        { this.props.users.map((row, index) => (
                            <TableRow key={ index }>
                                <TableRowColumn>
                                    { row.login ? row.login : "" }
                                </TableRowColumn>
                                <TableRowColumn>
                                    {row.lastname ? row.lastname : "" } {row.firstname ? row.firstname : "" }
                                </TableRowColumn>
                                <TableRowColumn>
                                    {row.mail ? row.mail : ""}
                                </TableRowColumn>
                                <TableRowColumn>
                                { 
                                    <IconButton 
                                        containerElement={ <span/> } 
                                        iconStyle={ styleUser.iconEdit } 
                                        tooltip="Sửa" 
                                        tooltipStyles={ styleUser.tooltipEdit }
                                        onTouchTap={ () => this.handleOpenEdit(row,row.login) }
                                    > 
                                        <EditorModeEdit 
                                            hoverColor={ styleUser.iconHoverColor.colorEdit } 
                                        />
                                    </IconButton> 
                                }
                                { 
                                    <IconButton 
                                        containerElement={ <span/> } 
                                        iconStyle={ styleUser.iconEdit } 
                                        tooltip="Xóa" 
                                        tooltipStyles={ styleUser.tooltipEdit } 
                                        onTouchTap={() => this.handleOpenDelete(row.id,row.login)}
                                    >
                                        <ActionDelete 
                                            hoverColor={ styleUser.iconHoverColor.colorRemove } 
                                        />
                                    </IconButton>
                                }
                                </TableRowColumn>
                            </TableRow>
                        )) }
                        
                    </TableBody>
                </Table>
            </div>
            );
    }
}

export class BtnAddUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    handleOpen = () => {
        this.setState({
            open: true
        });
    };

    handleClose = () => {
        this.setState({
            open: false
        });
    };

    render() {

        return (
            <div style={ styleUser.btnAddUser }>
              <RaisedButton label="Thêm" onTouchTap={ this.handleOpen } primary={ true } />
              <Dialog title="Thêm người dùng"  modal={ false } open={ this.state.open } onRequestClose={ this.handleClose } autoScrollBodyContent={ true }>
                <AddUser users={this.props.users} dispatch={this.props.dispatch} handleClose={this.handleClose}/>
              </Dialog>
            </div>
            );
    }
}

class ManageUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
          users:this.props.users,
          page:1,
          rowSizeList:[5,10,15,20],
          rowSize:10
        }
        autoBind(this);
    }

    // Sort Order
    handleSortOrderChange(key, order) {
      var sortList = SortListOrder(key,this.state.users,order)
      this.setState({users: sortList})
    }

    handleFilterValueChange(value) {
      console.log('filter value: ' + value);
    }

    handleCellClick(rowIndex, columnIndex, row, column) {
      console.log('rowIndex: ' + rowIndex + ' columnIndex: ' + columnIndex);
    }

    handleCellDoubleClick(rowIndex, columnIndex, row, column) {
      console.log('rowIndex: ' + rowIndex + ' columnIndex: ' + columnIndex);
    }

    handleRowSelection(selectedRows) {
      console.log('selectedRows: ' + selectedRows);
    }

    handleRowSizeChange(rowKey,rowValue) {
      let listArr = this.state.users;
      let showList = listArr.slice(0,rowValue);
      this.setState({
        rowSize:rowValue,
        users:showList
      })
    }

    handlePreviousPageClick() {
      console.log('handlePreviousPageClick');
      // this.setState({
      //   data: TABLE_DATA,
      //   page: 1,
      // });
    }

    handleNextPageClick() {
      console.log('handleNextPageClick');
      // this.setState({
      //   data: TABLE_DATA_NEXT,
      //   page: 2,
      // });
    }

    handlePersonAddClick() {
      console.log('handlePersonAddClick');
    }

    handleInfoClick() {
      console.log('handleInfoClick');
    }

    componentDidMount() {
        // this.props.dispatch(actions.selectUser(this.props.users));
    }

    static propTypes = {
        users: PropTypes.array,
    }

    static defaultProps = {
        users: [],
    }

    handleUpdateInput(value) {
        // this.setState({
        //     dataSource: [
        //         value,
        //         value + value,
        //         value + value + value,
        //     ],
        // });
        console.log(value);
    };
    searchFilter(name, id) {}
    onNewRequest(item, key) {
        console.log("item: ", item, "key: ", key);
    }
    render() {
        return (
            <div>
                <Row>
                    <Col xs={ 12 }>
                        <AutoComplete 
                            hintText="Tên đăng nhập" 
                            dataSource={this.props.users} 
                            onUpdateInput={ this.handleUpdateInput } 
                            floatingLabelText="Tìm kiếm" fullWidth={ true }
                            onNewRequest={ this.onNewRequest } 
                            maxSearchResults={ 5 } 
                            filter={ AutoComplete.noFilter } 
                        />
                    </Col>
                    <Col xs={ 12 }>
                        <Row start="xs">
                            <Col xs={ 6 }>
                                <BtnAddUser {...this.props}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col xs={ 12 }>
                        <Row center="xs">
                            <Col xs={ 12 }>
                              <Paper zDepth={1}>
                                <DataTables
                                  height={'auto'}
                                  selectable={false}
                                  showRowHover={true}
                                  columns={
                                    [
                                      {
                                      key:"login",
                                      label:"Tên đăng nhập",
                                      sortable: true,
                                      tooltip: 'Tên đăng nhập',
                                      },
                                      {
                                      key:"lastname",
                                      label:"Tên",
                                      sortable: true,
                                      tooltip: 'Tên',
                                      },
                                      {
                                      key:"firstname",
                                      label:"Họ",
                                      sortable: true,
                                      tooltip: 'Họ',
                                      },
                                      {
                                      key:"mail",
                                      label:"Email",
                                      sortable: true,
                                      tooltip: 'Email',
                                      },
                                    ]
                                  }
                                  data={this.state.users}
                                  showCheckboxes={false}
                                  onCellClick={this.handleCellClick}
                                  onCellDoubleClick={this.handleCellDoubleClick}
                                  onFilterValueChange={this.handleFilterValueChange}
                                  onSortOrderChange={this.handleSortOrderChange}
                                  onNextPageClick={this.handleNextPageClick}
                                  onPreviousPageClick={this.handlePreviousPageClick}
                                  onRowSelection={this.handleRowSelection}
                                  onRowSizeChange={this.handleRowSizeChange}
                                  page={1}
                                  count={50}
                                  initialSort={{column:'login',order:'asc'}}
                                  filterHintText={"Tìm kiếm"}
                                  rowSize={this.state.rowSize}
                                  rowSizeList={this.state.rowSizeList}
                                  rowSizeLabel={"Số dòng trên 1 trang"}
                                  showHeaderToolbar={true}
                                />
                              </Paper>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ManageUser;


// WEBPACK FOOTER //
// ./src/components/users/ManageUsers.js